import React, { Fragment } from 'react';

import FaqBox from '@src/Components/Atoms/FaqBox/FaqBox';

import SocialButtons from '@src/Components/Atoms/SocialButtons/SocialButtons';
import styles from './Faq.module.scss';

const Faq = () => {
  return (
    <div
      className={styles['faq-box']}
      style={{
        background: 'url(./assets/img/png/Retainer/background/squarebg.png)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
      data-testid="faq-section"
    >
      <div className={styles['faq-container']}>
        <div>
          <p className={styles['faq-title']}>
            WHY CAN’T I ENTER RETAINER ACADEMY?
          </p>
          <div>
            <FaqBox
              title={
                'You need to be approved as a Constituent after undertaking the Induction Hub module'
              }
            >
              <p>
                You have to complete the Induction Hub process first. Such as
                registering an account and completing the induction hub until
                you obtain one of the Archetypes. If you are eligible, then you
                will be approved as a Constituent by the Council.
              </p>
            </FaqBox>
            <p className={styles['faq-separator']}>OR</p>
            <FaqBox
              title={'You need to input a referral code from our Ambassadors'}
            >
              <Fragment>
                <p>
                  You have to find the referral code from our Ambassadors. You
                  can look for it in the existing communities, such as Twitter
                  or Discord Mythic Protocol.
                </p>
                <div className={styles['social-container']}>
                  <SocialButtons
                    link="https://discord.gg/mythicprotocol"
                    caption="Discord"
                    icon={
                      <svg
                        width="28"
                        height="22"
                        viewBox="0 0 28 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M23.7031 2.59761C21.9181 1.79261 20.0048 1.19761 18.004 0.859277C17.9861 0.855856 17.9677 0.858061 17.9512 0.865585C17.9347 0.87311 17.9209 0.885583 17.9118 0.901277C17.6668 1.33178 17.3938 1.89294 17.2024 2.33628C15.0804 2.01922 12.923 2.01922 10.801 2.33628C10.5878 1.84495 10.3475 1.36587 10.0811 0.901277C10.0721 0.88539 10.0584 0.872635 10.042 0.864714C10.0255 0.856792 10.007 0.854082 9.98895 0.856943C7.98928 1.19528 6.07595 1.79028 4.28978 2.59644C4.27442 2.60289 4.26139 2.61388 4.25245 2.62794C0.621784 7.96544 -0.373383 13.1711 0.11545 18.3114C0.116811 18.324 0.120718 18.3362 0.126936 18.3472C0.133154 18.3583 0.141551 18.3679 0.151617 18.3756C2.27074 19.9184 4.63434 21.0937 7.14345 21.8523C7.16094 21.8577 7.17965 21.8576 7.19713 21.8522C7.21461 21.8468 7.23006 21.8363 7.24145 21.8219C7.78138 21.0999 8.25983 20.3338 8.67178 19.5318C8.6775 19.5208 8.6808 19.5087 8.68145 19.4964C8.6821 19.484 8.68009 19.4717 8.67555 19.4602C8.67101 19.4487 8.66406 19.4383 8.65516 19.4297C8.64625 19.4211 8.63561 19.4146 8.62395 19.4104C7.87029 19.1266 7.14005 18.7841 6.43995 18.3861C6.42737 18.3789 6.41677 18.3687 6.4091 18.3565C6.40143 18.3442 6.39693 18.3302 6.39601 18.3157C6.39508 18.3013 6.39776 18.2868 6.4038 18.2736C6.40984 18.2605 6.41905 18.249 6.43062 18.2403C6.57762 18.1318 6.72462 18.0186 6.86462 17.9054C6.87722 17.8953 6.8924 17.8888 6.90846 17.8867C6.92453 17.8847 6.94086 17.8871 6.95562 17.8938C11.5371 19.9518 16.499 19.9518 21.0268 17.8938C21.0416 17.8867 21.0581 17.884 21.0744 17.8858C21.0907 17.8877 21.1061 17.8941 21.1189 17.9043C21.2589 18.0186 21.4048 18.1318 21.5529 18.2403C21.5646 18.2488 21.574 18.2601 21.5802 18.2732C21.5865 18.2862 21.5894 18.3006 21.5887 18.3151C21.588 18.3295 21.5837 18.3436 21.5763 18.356C21.5688 18.3684 21.5584 18.3787 21.5459 18.3861C20.8483 18.7874 20.1226 19.1269 19.3608 19.4093C19.3491 19.4135 19.3384 19.4202 19.3295 19.4289C19.3206 19.4376 19.3137 19.4481 19.3091 19.4597C19.3046 19.4713 19.3026 19.4837 19.3033 19.4961C19.3039 19.5086 19.3072 19.5207 19.313 19.5318C19.733 20.3333 20.2136 21.0963 20.7421 21.8208C20.7531 21.8356 20.7684 21.8468 20.7859 21.8526C20.8035 21.8585 20.8224 21.8587 20.8401 21.8534C23.3535 21.097 25.721 19.9212 27.8424 18.3756C27.8528 18.3684 27.8615 18.359 27.8679 18.3481C27.8744 18.3373 27.8784 18.3252 27.8798 18.3126C28.4631 12.3696 26.9021 7.20594 23.7393 2.63028C23.7315 2.61541 23.7187 2.60382 23.7031 2.59761ZM9.35662 15.1813C7.97762 15.1813 6.84012 13.9341 6.84012 12.4046C6.84012 10.8739 7.95545 9.62794 9.35662 9.62794C10.7683 9.62794 11.8953 10.8844 11.8731 12.4046C11.8731 13.9353 10.7578 15.1813 9.35662 15.1813ZM18.6608 15.1813C17.2806 15.1813 16.1443 13.9341 16.1443 12.4046C16.1443 10.8739 17.2584 9.62794 18.6608 9.62794C20.0724 9.62794 21.1994 10.8844 21.1773 12.4046C21.1773 13.9353 20.0736 15.1813 18.6608 15.1813Z"
                          fill="#EFEFF0"
                        />
                      </svg>
                    }
                  />
                  <SocialButtons
                    link="https://twitter.com/mythicprotocol"
                    caption="Twitter"
                    icon={
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 36 36"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M34.3561 8.12006C33.1662 8.64731 31.888 9.00356 30.5442 9.16459C31.9307 8.33494 32.968 7.02918 33.4626 5.49094C32.1599 6.2647 30.7342 6.80934 29.2474 7.10119C28.2476 6.03367 26.9233 5.3261 25.4802 5.08834C24.037 4.85057 22.5558 5.09592 21.2663 5.78627C19.9769 6.47663 18.9515 7.57338 18.3492 8.90624C17.747 10.2391 17.6017 11.7335 17.9358 13.1574C15.2962 13.0249 12.714 12.3388 10.3568 11.1438C7.99957 9.94871 5.91995 8.27134 4.25293 6.22054C3.68292 7.20379 3.35518 8.34379 3.35518 9.55789C3.35454 10.6509 3.62369 11.7271 4.13875 12.6911C4.65381 13.6551 5.39886 14.477 6.30778 15.084C5.25367 15.0505 4.22282 14.7657 3.30103 14.2533V14.3388C3.30092 15.8717 3.83117 17.3575 4.80181 18.5439C5.77245 19.7304 7.12369 20.5445 8.62625 20.8482C7.64839 21.1128 6.62318 21.1518 5.62805 20.9622C6.05198 22.2812 6.87777 23.4346 7.9898 24.2609C9.10183 25.0873 10.4444 25.5452 11.8297 25.5706C9.47816 27.4166 6.57409 28.4179 3.5846 28.4135C3.05504 28.4136 2.52593 28.3827 2 28.3209C5.0345 30.2719 8.56689 31.3074 12.1745 31.3034C24.3868 31.3034 31.0629 21.1887 31.0629 12.4164C31.0629 12.1314 31.0558 11.8436 31.0429 11.5586C32.3415 10.6195 33.4625 9.45656 34.3532 8.12434L34.3561 8.12006Z"
                          fill="#EFEFF0"
                        />
                      </svg>
                    }
                  />
                </div>
              </Fragment>
            </FaqBox>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
